import { useCallback, useState } from "react";

import EmployeePerformanceAssessmentResults from "../pages/EmployeePerformanceAssessmentResults";
import EmployeePerformanceLearning from "../pages/EmployeePerformanceLearning";
import EmployeePerformanceSkill from "../pages/EmployeePerformanceSkill";
import EmployeePerformanceTraining from "../pages/EmployeePerformanceTraining";

import { EMPLOYEE_PERFORMANCE_PAGE } from "../schemas/employeePerformanceSchema";

function useEmployeePerformance() {
  const [selectedMenu, setMenu] = useState(EMPLOYEE_PERFORMANCE_PAGE.LEARNING);

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case EMPLOYEE_PERFORMANCE_PAGE.LEARNING:
        return <EmployeePerformanceLearning />;
      case EMPLOYEE_PERFORMANCE_PAGE.TRAINING:
        return <EmployeePerformanceTraining />;
      case EMPLOYEE_PERFORMANCE_PAGE.SKILL:
        return <EmployeePerformanceSkill />;
      case EMPLOYEE_PERFORMANCE_PAGE.ASSESSMENT_RESULTS:
        return <EmployeePerformanceAssessmentResults />;
      default:
        return <div />;
    }
  }, [selectedMenu]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  return { getPage, handleMenuChange };
}

export default useEmployeePerformance;
